import type { AttributesEntity } from '@eliadmin/core/src/api/products/types/product-types';
import { Checkbox } from '@eliadmin/core/src/components/ui/checkbox';
import { Label } from '@eliadmin/core/src/components/ui/label';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export default function ProductVariantCheckbox({ attribute }: { attribute: AttributesEntity }) {
  const selectedValues = useVariantsStore(state => state.selectedValues);
  const updateSelectedValue = useVariantsStore(state => state.updateSelectedValue);

  return (
    <div className={cn('grid grid-cols-12', 'ea-product-detail-variant__checkbox')}>
      {attribute.values?.map((value: any, i: any) => {
        const selected = selectedValues.some(
          selectedValue =>
            selectedValue.attribute.id === attribute.id && selectedValue.value.id === value.id,
        );
        return (
          <div
            key={`attribute-checkbox-${i}`}
            className={cn(
              'col-span-12 mt-2 flex flex-row items-center md:col-span-6 lg:col-span-4',
              'ea-product-detail-variant__checkbox_wrapper',
            )}
          >
            <Checkbox className={cn('mr-2', 'ea-product-detail-variant__checkbox-input')}>
              <input
                type="checkbox"
                id={`attribute-checkbox-${value.id}`}
                checked={selected}
                onChange={() => {
                  if (!selected) updateSelectedValue({ attribute, value });
                }}
              />
            </Checkbox>
            <Label
              htmlFor={`attribute-checkbox-${value.id}`}
              className={cn('', 'ea-product-detail-variant__checkbox-label')}
            >
              {value.name}
            </Label>
          </div>
        );
      })}
    </div>
  );
}
